const endCapsLine = (fabricCanvas, fabric) => {
    let isDrawingEndCapsLine = false
    let line = null
    let startCap = null
    let endCap = null

    const createCap = (x, y, angle) => {
        // This function creates a small line (cap) that is perpendicular to the main line
        const length = 10 // Length of the cap
        const radians = fabric.util.degreesToRadians(angle + 90) // Rotate the cap to be perpendicular
        const dx = length * Math.cos(radians)
        const dy = length * Math.sin(radians)

        return new fabric.Line([x - dx, y - dy, x + dx, y + dy], {
            stroke: window.globalColor,
            strokeWidth: 2,
            selectable: false,
            originX: 'center',
            originY: 'center'
        })
    }

    fabricCanvas.on('mouse:down', (o) => {
        if (!fabricCanvas.isDrawingEndCapsLineMode) return

        if (fabricCanvas?.getActiveObject()) return

        isDrawingEndCapsLine = true
        const pointer = fabricCanvas.getPointer(o.e)

        // Initialize the line
        line = new fabric.Line([pointer.x, pointer.y, pointer.x, pointer.y], {
            stroke: window.globalColor,
            strokeWidth: 2,
            selectable: false
        })
        fabricCanvas.add(line)

        // Initialize the starting cap, angle is 0 for now
        startCap = createCap(pointer.x, pointer.y, 0)
        //  console.log('StartCap')
        fabricCanvas.add(startCap)
    })

    fabricCanvas.on('mouse:move', (o) => {
        if (!isDrawingEndCapsLine) return

        const pointer = fabricCanvas.getPointer(o.e)

        // Update the end position of the line
        line.set({ x2: pointer.x, y2: pointer.y })

        // Calculate the angle of the line
        const angle =
            Math.atan2(pointer.y - line.y1, pointer.x - line.x1) *
            (180 / Math.PI)

        // Update the starting cap
        fabricCanvas.remove(startCap)
        startCap = createCap(line.x1, line.y1, angle)
        fabricCanvas.add(startCap)

        // Update or create the ending cap
        if (endCap) {
            fabricCanvas.remove(endCap) // Remove the previous end cap to update
        }
        endCap = createCap(pointer.x, pointer.y, angle)
        fabricCanvas.add(endCap)

        fabricCanvas.requestRenderAll()
    })

    fabricCanvas.on('mouse:up', () => {
        if (!isDrawingEndCapsLine) return

        isDrawingEndCapsLine = false

        // Group the line and caps together for collective manipulation
        if (line && startCap && endCap) {
            const group = new fabric.Group([line, startCap, endCap], {
                selectable: true
            })

            fabricCanvas.add(group)
            fabricCanvas.remove(line)
            fabricCanvas.remove(startCap)
            fabricCanvas.remove(endCap)
        }

        fabricCanvas.requestRenderAll()

        // Reset variables
        line = null
        startCap = null
        endCap = null
    })
}

export default endCapsLine
